module.exports = __webpack_public_path__ + "media/2.512b27bd.mp4";